import AutopassRouter from "app-router/autopass/autopass-router";

export default AutopassRouter
